import commonGame from '../commonGame';
import common from '../common';
import ConfirmationPanel from './overlays/ConfirmationPanel';
import TrashConfirmationPanel from './overlays/TrashConfirmationPanel';

const _onQuitButtonClick = Symbol('_onQuitButtonClick');
const _onPrintButtonClick = Symbol('_onPrintButtonClick');
const _onDownloadButtonClick = Symbol('_onDownloadButtonClick');
const _onBinButtonClick = Symbol('_onBinButtonClick');
const _onBackButtonClick = Symbol('_onBackButtonClick');

export default class MenuPanel extends PIXI.Container {
	constructor(signals) {
		super();

		this._gameSceneSignals = signals;

		// Attributes.
		this._quitBtn = null;
		this._backBtn = null;
		this._printBtn = null;
		this._downloadBtn = null;
		this._muteBtn = null;
		this._binBtn = null;
		this._boxBorderSprite = null;
		this._popupContainer = null;
		this._drawingActionContainer = null;
		this._titleSprite = null;
		this._bgGradientSprite = null;
		this._titleText = null;
		this._confirmationPanel = null;
		this._trashConfirmationPanel = null;

		this._tweens = new P3.utils.TWEEN.Group();
	}

	init() {
		const panelConfig = common.levelConfig.menu_panel;

		// Bg gradient sprite.
		this._bgGradientSprite = new PIXI.Sprite(PIXI.Texture.WHITE);
		this._bgGradientSprite.tint = 0x000000;
		this._bgGradientSprite.alpha = 0.6;
		this._bgGradientSprite.anchor = new PIXI.Point(0.5, 0.5);
		this._bgGradientSprite.scale.x = common.STAGE_WIDTH * 1.25;
		this._bgGradientSprite.scale.y = common.STAGE_HEIGHT;
		this._bgGradientSprite.interactive = true;
		this._bgGradientSprite.click = this._bgGradientSprite.touchend = this[_onBackButtonClick].bind(this);
		this.addChild(this._bgGradientSprite);

		// Popup.
		this._popupContainer = new PIXI.Container();
		this._popupContainer.anchor = new PIXI.Point(0.5, 0.5);
		this.addChild(this._popupContainer);

		// Border.
		this._boxBorderSprite = new PIXI.Sprite(P3.assets.texture(panelConfig.bg.texture));
		this._boxBorderSprite.anchor = new PIXI.Point(panelConfig.bg.anchor.x, panelConfig.bg.anchor.y);
		this._boxBorderSprite.position.set(panelConfig.bg.position.x, panelConfig.bg.position.y);
		this._boxBorderSprite.scale.set(panelConfig.bg.scale.x, panelConfig.bg.scale.y);

		this._boxBorderSprite._topBar = new PIXI.Sprite(P3.assets.texture(panelConfig.top_bar.texture));
		this._boxBorderSprite._topBar.anchor.set(panelConfig.top_bar.anchor.x, panelConfig.top_bar.anchor.y);
		this._boxBorderSprite._topBar.position.set(
			panelConfig.top_bar.position.x,
			(-this._boxBorderSprite.height * 0.5 + this._boxBorderSprite._topBar.height * 0.5 - 25) + panelConfig.top_bar.position.y
		);
		this._boxBorderSprite._topBar.scale.set(panelConfig.top_bar.scale.x, panelConfig.top_bar.scale.y);

		this._boxBorderSprite.addChild(this._boxBorderSprite._topBar);
		this._popupContainer.addChild(this._boxBorderSprite);
		this._popupContainer.scale.set(0.9, 0.9);

		// Title sprite.
		this._titleSprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
		this._titleSprite.anchor = new PIXI.Point(0.5, 0.5);

		this._popupContainer.addChild(this._titleSprite);

		// Title text.
		// let bkText = P3.createText('MENU', {
		// 	fill: 'white',
		// 	stroke: '#2c1812',
		// 	size: '70px',
		// 	wordWrap: true,
		// 	wordWrapWidth: 500,
		// 	strokeThickness: 14,
		// 	align: 'centre'
		// });

		this._titleText = P3.createText('MENU', {
			fill: 'white',
			stroke: '#2c1812',
			size: '70px',
			wordWrap: true,
			wordWrapWidth: 500,
			align: 'centre',
			strokeThickness: 8
		});

		this._titleText.position.set(
			panelConfig.title.position.x,
			(-this._boxBorderSprite.height * 0.5 + 75) + panelConfig.title.position.y
		);
		this._titleText.anchor = new PIXI.Point(panelConfig.title.anchor.x, panelConfig.title.anchor.y);
		this._titleSprite.addChild(this._titleText);

		// Quit button.
		const buttonsConfig = panelConfig.buttons;
		this._quitBtn = createButton('home');
		this._quitBtn.position = new PIXI.Point(
			-200 + buttonsConfig.bottom_row.position.x,
			this._boxBorderSprite.height * 0.5 - 115 + buttonsConfig.bottom_row.position.y
		);
		this._quitBtn.overSoundName = 'sfx_ui_rollover_00';
		this._quitBtn.downSoundName = 'sfx_ui_click_00';
		this._quitBtn.signals.click.add(this[_onQuitButtonClick], this);
		this._popupContainer.addChild(this._quitBtn);

		// Sound button.
		this._muteBtn = createButton('sound');
		this._muteBtn.position = new PIXI.Point(
			200 + buttonsConfig.bottom_row.position.x,
			this._boxBorderSprite.height * 0.5 - 115 + buttonsConfig.bottom_row.position.y
		);
		this._muteBtn.overSoundName = 'sfx_ui_rollover_00';
		this._muteBtn.downSoundName = 'sfx_ui_click_00';
		this._popupContainer.addChild(this._muteBtn);

		// Container for Print, Download and Bin buttons.
		this._drawingActionContainer = new PIXI.Sprite(PIXI.Texture.EMPTY);
		this._drawingActionContainer.anchor.set(0.5, 0.5);
		this._drawingActionContainer.y = -15;
		this._popupContainer.addChild(this._drawingActionContainer);

		const btnOffset = 190;
		let btnStatesAux;

		// Print button.
		if (common.gameConfig.menuPanel.printBtn.isVisible) {
			btnStatesAux = new P3.ButtonStates(
				PIXI.Texture.EMPTY,
				PIXI.Texture.EMPTY,
				PIXI.Texture.EMPTY,
				P3.assets.texture('icon_print')
			);
			this._printBtn = new P3.Button(btnStatesAux);
			this._printBtn.position.set(-btnOffset + buttonsConfig.top_row.position.x, buttonsConfig.top_row.position.y);
			this._printBtn.x = -btnOffset;
			this._printBtn.scale.set(0.9);

			this._printBtn.signals.click.add(this[_onPrintButtonClick], this);
			this._drawingActionContainer.addChild(this._printBtn);
		}

		// Download button.
		if (common.gameConfig.menuPanel.downloadBtn.isVisible) {
			btnStatesAux = new P3.ButtonStates(
				PIXI.Texture.EMPTY,
				PIXI.Texture.EMPTY,
				PIXI.Texture.EMPTY,
				P3.assets.texture('icon_save'));
			this._downloadBtn = new P3.Button(btnStatesAux);
			this._downloadBtn.position.set(buttonsConfig.top_row.position.x, buttonsConfig.top_row.position.y);
			this._downloadBtn.scale.set(0.9);

			this._downloadBtn.signals.click.add(this[_onDownloadButtonClick], this);
			this._drawingActionContainer.addChild(this._downloadBtn);
		}

		// Bin button.
		if (common.gameConfig.menuPanel.binBtn.isVisible) {
			btnStatesAux = new P3.ButtonStates(
				PIXI.Texture.EMPTY,
				PIXI.Texture.EMPTY,
				PIXI.Texture.EMPTY,
				P3.assets.texture('icon_replay'));
			this._binBtn = new P3.Button(btnStatesAux);
			this._binBtn.scale.set(0.9);
			this._binBtn.position.set(btnOffset + buttonsConfig.top_row.position.x, buttonsConfig.top_row.position.y);

			this._binBtn.signals.click.add(this[_onBinButtonClick], this);
			this._drawingActionContainer.addChild(this._binBtn);
		}

		// Back button.
		this._backBtn = createButton('play', 'primary_large');
		this._backBtn.position.set(0 + buttonsConfig.bottom_row.position.x, this._boxBorderSprite.height * 0.5 - 115 + buttonsConfig.bottom_row.position.y);
		this._backBtn.overSoundName = 'sfx_ui_rollover_00';
		this._backBtn.downSoundName = 'sfx_ui_click_00';
		this._backBtn.signals.click.add(this[_onBackButtonClick], this);
		this._popupContainer.addChild(this._backBtn);

		// Confirmation panel.
		this._confirmationPanel = new ConfirmationPanel();
		this._confirmationPanel.anchor = new PIXI.Point(0.5, 0.5);
		this._confirmationPanel.init();
		this.addChild(this._confirmationPanel);

		// Trash confirmation panel.
		this._trashConfirmationPanel = new TrashConfirmationPanel();
		this._trashConfirmationPanel.anchor = new PIXI.Point(0.5, 0.5);
		this._trashConfirmationPanel.init();
		this.addChild(this._trashConfirmationPanel);

		this.visible = false;
		this.alpha = 0;
	}

	show() {
		// Animate-in.
		this.visible = true;
		this._popupContainer.y = -50;
		new P3.utils.TWEEN.Tween(this, this.tweens)
		    .to({
		        alpha: 1
		    }, 250)
		    .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
		    .start();

		new P3.utils.TWEEN.Tween(this._popupContainer, this.tweens)
		    .to({
		        y: 0
		    }, 250)
		    .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
		    .start();

		this._backBtn.alpha = 0;
		this._backBtn.scale = new PIXI.Point();

		new P3.utils.TWEEN.Tween(this._backBtn.scale, this.tweens)
			.to({
				x: 1, y: 1
			}, 340)
			.delay(200)
			.easing(P3.utils.Easing.Back2.Out)
			.onUpdate(()=> {
				this._backBtn.alpha = this._backBtn.scale.x;
			})
			.start();

		common.game.scene.addTutorialEvent(commonGame.TUT_EVENT.MENU_PANEL_SHOWN);
	}

	destroy(options) {
		this.tweens.removeAll();
		super.destroy();
	}

	update() {
		this.tweens.update();
		this._confirmationPanel.update();
		this._trashConfirmationPanel.update();
	}

	[_onQuitButtonClick]() {
		this._confirmationPanel.signals.onYes.once(
			()=> {
				// Music.
				P3.audio.playMusic('music_winter_magic_loop_00');
				this._gameSceneSignals.previous.dispatch();
			}, this);
		this._confirmationPanel.show(P3.assets.json('languages').LEAVE_CONFIRMATION[common.config.language]);
	}

	[_onPrintButtonClick]() {
		// Sfx.
		P3.audio.playSound('sfx_ui_newpage_00');

		this.visible = false;
		common.game.hud.visible = false;

		//--timeout is needed. otherwise window.open returns null (according to SO must be initialised by a native event)--//
		setTimeout(()=> {
			const canvas = common.renderer.extract.canvas(common.game.canvas);
			const dataUrl = canvas.toDataURL();

			let windowContent = '<!DOCTYPE html>';
			windowContent += '<html>';
			windowContent += '<head><title>Print canvas</title></head>';
			windowContent += '<body>';
			windowContent += '<img src="' + dataUrl + '">';
			windowContent += '</body>';
			windowContent += '</html>';

			const printWin = window.open('', '', 'width=' + screen.availWidth + ',height=' + screen.availHeight);
			printWin.document.open();
			printWin.document.write(windowContent);
			if (common.detectIE() === false) {
				printWin.document.addEventListener('load', function() {
					printWin.focus();
					printWin.print();
					printWin.document.close();
					printWin.close();
				}, true);
			} else {
				printWin.focus();
				printWin.print();
				printWin.document.close();
				printWin.close();
			}

			// console.log(canvas);
			// const myWindow = window.open();
			// if (myWindow) {
			// 	myWindow.document.body.appendChild(canvas);
			//
			// 	const css = '@page { size: landscape; margin-top: 0.1cm; margin-left: 2.3cm; }';
			// 	const head = myWindow.document.head || myWindow.document.getElementsByTagName('head')[0];
			// 	const style = document.createElement('style');
			//
			// 	style.type = 'text/css';
			// 	style.media = 'print';
			//
			// 	style.styleSheet ? style.styleSheet.cssText = css :	style.appendChild(document.createTextNode(css));
			//
			// 	head.appendChild(style);
			//
			// 	myWindow.print();
			// 	myWindow.close();
			// } else {
			// 	console.error('unable to open new window');
			// 	console.log(myWindow);
			// }

			this.visible = true;
			common.game.hud.visible = true;
		}, 2.5);
	}

	[_onDownloadButtonClick]() {
		// Sfx.
		P3.audio.playSound('sfx_ui_folder_save_00');

		this.visible = false;
		common.game.hud.visible = false;

		setTimeout(()=> {
			const canvas = common.renderer.extract.canvas(common.game.canvas);
			const myWindow = window.open();
			if (myWindow != null)
				myWindow.document.body.appendChild(canvas);

			this.visible = true;
			common.game.hud.visible = true;
		}, 2.5);
	}

	[_onBinButtonClick]() {
		this._trashConfirmationPanel.signals.onYes.once(()=> {
			P3.audio.playSound('sfx_tool_trashcan_select_00');
			common.game.canvas.clear();
			common.game.undoManager.clear();
			for (const allStamp of common.gameScene.allStamps)
				common.gameScene.gameLayer.removeChild(allStamp);
			common.gameScene.allStamps = [];
			this.visible = false;
		}, this);
		this._trashConfirmationPanel.show(P3.assets.json('languages').BIN_CONFIRMATION[common.config.language]);
	}

	[_onBackButtonClick]() {
		new P3.utils.TWEEN.Tween(this, this.tweens)
		    .to({
		        alpha: 0
		    }, 250)
		    .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
		    .start();

		new P3.utils.TWEEN.Tween(this._popupContainer, this.tweens)
		    .to({
		        y: 50
		    }, 250)
		    .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
		    .onComplete(()=> {
				this.visible = false;
				common.game.scene.addTutorialEvent(commonGame.TUT_EVENT.MENU_PANEL_HIDDEN);
		    })
		    .start();
	}

	get tweens() {
		return this._tweens;
	}
}
